__turbopack_context__.v({
  "ai-lg-baseline": "YLaBPa_ai-lg-baseline",
  "ai-lg-center": "YLaBPa_ai-lg-center",
  "ai-lg-end": "YLaBPa_ai-lg-end",
  "ai-lg-flex-end": "YLaBPa_ai-lg-flex-end",
  "ai-lg-flex-start": "YLaBPa_ai-lg-flex-start",
  "ai-lg-normal": "YLaBPa_ai-lg-normal",
  "ai-lg-self-end": "YLaBPa_ai-lg-self-end",
  "ai-lg-self-start": "YLaBPa_ai-lg-self-start",
  "ai-lg-start": "YLaBPa_ai-lg-start",
  "ai-lg-stretch": "YLaBPa_ai-lg-stretch",
  "ai-md-baseline": "YLaBPa_ai-md-baseline",
  "ai-md-center": "YLaBPa_ai-md-center",
  "ai-md-end": "YLaBPa_ai-md-end",
  "ai-md-flex-end": "YLaBPa_ai-md-flex-end",
  "ai-md-flex-start": "YLaBPa_ai-md-flex-start",
  "ai-md-normal": "YLaBPa_ai-md-normal",
  "ai-md-self-end": "YLaBPa_ai-md-self-end",
  "ai-md-self-start": "YLaBPa_ai-md-self-start",
  "ai-md-start": "YLaBPa_ai-md-start",
  "ai-md-stretch": "YLaBPa_ai-md-stretch",
  "ai-sm-baseline": "YLaBPa_ai-sm-baseline",
  "ai-sm-center": "YLaBPa_ai-sm-center",
  "ai-sm-end": "YLaBPa_ai-sm-end",
  "ai-sm-flex-end": "YLaBPa_ai-sm-flex-end",
  "ai-sm-flex-start": "YLaBPa_ai-sm-flex-start",
  "ai-sm-normal": "YLaBPa_ai-sm-normal",
  "ai-sm-self-end": "YLaBPa_ai-sm-self-end",
  "ai-sm-self-start": "YLaBPa_ai-sm-self-start",
  "ai-sm-start": "YLaBPa_ai-sm-start",
  "ai-sm-stretch": "YLaBPa_ai-sm-stretch",
  "ai-xl-baseline": "YLaBPa_ai-xl-baseline",
  "ai-xl-center": "YLaBPa_ai-xl-center",
  "ai-xl-end": "YLaBPa_ai-xl-end",
  "ai-xl-flex-end": "YLaBPa_ai-xl-flex-end",
  "ai-xl-flex-start": "YLaBPa_ai-xl-flex-start",
  "ai-xl-normal": "YLaBPa_ai-xl-normal",
  "ai-xl-self-end": "YLaBPa_ai-xl-self-end",
  "ai-xl-self-start": "YLaBPa_ai-xl-self-start",
  "ai-xl-start": "YLaBPa_ai-xl-start",
  "ai-xl-stretch": "YLaBPa_ai-xl-stretch",
  "cell": "YLaBPa_cell",
  "cell-column-lg-1": "YLaBPa_cell-column-lg-1",
  "cell-column-lg-2": "YLaBPa_cell-column-lg-2",
  "cell-column-lg-3": "YLaBPa_cell-column-lg-3",
  "cell-column-lg-4": "YLaBPa_cell-column-lg-4",
  "cell-column-lg-5": "YLaBPa_cell-column-lg-5",
  "cell-column-lg-6": "YLaBPa_cell-column-lg-6",
  "cell-column-lg-auto": "YLaBPa_cell-column-lg-auto",
  "cell-column-lg-span-1": "YLaBPa_cell-column-lg-span-1",
  "cell-column-lg-span-10": "YLaBPa_cell-column-lg-span-10",
  "cell-column-lg-span-11": "YLaBPa_cell-column-lg-span-11",
  "cell-column-lg-span-12": "YLaBPa_cell-column-lg-span-12",
  "cell-column-lg-span-2": "YLaBPa_cell-column-lg-span-2",
  "cell-column-lg-span-3": "YLaBPa_cell-column-lg-span-3",
  "cell-column-lg-span-4": "YLaBPa_cell-column-lg-span-4",
  "cell-column-lg-span-5": "YLaBPa_cell-column-lg-span-5",
  "cell-column-lg-span-6": "YLaBPa_cell-column-lg-span-6",
  "cell-column-lg-span-7": "YLaBPa_cell-column-lg-span-7",
  "cell-column-lg-span-8": "YLaBPa_cell-column-lg-span-8",
  "cell-column-lg-span-9": "YLaBPa_cell-column-lg-span-9",
  "cell-column-md-1": "YLaBPa_cell-column-md-1",
  "cell-column-md-2": "YLaBPa_cell-column-md-2",
  "cell-column-md-3": "YLaBPa_cell-column-md-3",
  "cell-column-md-4": "YLaBPa_cell-column-md-4",
  "cell-column-md-5": "YLaBPa_cell-column-md-5",
  "cell-column-md-6": "YLaBPa_cell-column-md-6",
  "cell-column-md-auto": "YLaBPa_cell-column-md-auto",
  "cell-column-md-span-1": "YLaBPa_cell-column-md-span-1",
  "cell-column-md-span-10": "YLaBPa_cell-column-md-span-10",
  "cell-column-md-span-11": "YLaBPa_cell-column-md-span-11",
  "cell-column-md-span-12": "YLaBPa_cell-column-md-span-12",
  "cell-column-md-span-2": "YLaBPa_cell-column-md-span-2",
  "cell-column-md-span-3": "YLaBPa_cell-column-md-span-3",
  "cell-column-md-span-4": "YLaBPa_cell-column-md-span-4",
  "cell-column-md-span-5": "YLaBPa_cell-column-md-span-5",
  "cell-column-md-span-6": "YLaBPa_cell-column-md-span-6",
  "cell-column-md-span-7": "YLaBPa_cell-column-md-span-7",
  "cell-column-md-span-8": "YLaBPa_cell-column-md-span-8",
  "cell-column-md-span-9": "YLaBPa_cell-column-md-span-9",
  "cell-column-sm-1": "YLaBPa_cell-column-sm-1",
  "cell-column-sm-2": "YLaBPa_cell-column-sm-2",
  "cell-column-sm-3": "YLaBPa_cell-column-sm-3",
  "cell-column-sm-4": "YLaBPa_cell-column-sm-4",
  "cell-column-sm-5": "YLaBPa_cell-column-sm-5",
  "cell-column-sm-6": "YLaBPa_cell-column-sm-6",
  "cell-column-sm-auto": "YLaBPa_cell-column-sm-auto",
  "cell-column-sm-span-1": "YLaBPa_cell-column-sm-span-1",
  "cell-column-sm-span-10": "YLaBPa_cell-column-sm-span-10",
  "cell-column-sm-span-11": "YLaBPa_cell-column-sm-span-11",
  "cell-column-sm-span-12": "YLaBPa_cell-column-sm-span-12",
  "cell-column-sm-span-2": "YLaBPa_cell-column-sm-span-2",
  "cell-column-sm-span-3": "YLaBPa_cell-column-sm-span-3",
  "cell-column-sm-span-4": "YLaBPa_cell-column-sm-span-4",
  "cell-column-sm-span-5": "YLaBPa_cell-column-sm-span-5",
  "cell-column-sm-span-6": "YLaBPa_cell-column-sm-span-6",
  "cell-column-sm-span-7": "YLaBPa_cell-column-sm-span-7",
  "cell-column-sm-span-8": "YLaBPa_cell-column-sm-span-8",
  "cell-column-sm-span-9": "YLaBPa_cell-column-sm-span-9",
  "cell-column-xl-1": "YLaBPa_cell-column-xl-1",
  "cell-column-xl-2": "YLaBPa_cell-column-xl-2",
  "cell-column-xl-3": "YLaBPa_cell-column-xl-3",
  "cell-column-xl-4": "YLaBPa_cell-column-xl-4",
  "cell-column-xl-5": "YLaBPa_cell-column-xl-5",
  "cell-column-xl-6": "YLaBPa_cell-column-xl-6",
  "cell-column-xl-auto": "YLaBPa_cell-column-xl-auto",
  "cell-column-xl-span-1": "YLaBPa_cell-column-xl-span-1",
  "cell-column-xl-span-10": "YLaBPa_cell-column-xl-span-10",
  "cell-column-xl-span-11": "YLaBPa_cell-column-xl-span-11",
  "cell-column-xl-span-12": "YLaBPa_cell-column-xl-span-12",
  "cell-column-xl-span-2": "YLaBPa_cell-column-xl-span-2",
  "cell-column-xl-span-3": "YLaBPa_cell-column-xl-span-3",
  "cell-column-xl-span-4": "YLaBPa_cell-column-xl-span-4",
  "cell-column-xl-span-5": "YLaBPa_cell-column-xl-span-5",
  "cell-column-xl-span-6": "YLaBPa_cell-column-xl-span-6",
  "cell-column-xl-span-7": "YLaBPa_cell-column-xl-span-7",
  "cell-column-xl-span-8": "YLaBPa_cell-column-xl-span-8",
  "cell-column-xl-span-9": "YLaBPa_cell-column-xl-span-9",
  "cell-columngap-lg-1": "YLaBPa_cell-columngap-lg-1",
  "cell-columngap-lg-10": "YLaBPa_cell-columngap-lg-10",
  "cell-columngap-lg-11": "YLaBPa_cell-columngap-lg-11",
  "cell-columngap-lg-12": "YLaBPa_cell-columngap-lg-12",
  "cell-columngap-lg-13": "YLaBPa_cell-columngap-lg-13",
  "cell-columngap-lg-14": "YLaBPa_cell-columngap-lg-14",
  "cell-columngap-lg-2": "YLaBPa_cell-columngap-lg-2",
  "cell-columngap-lg-3": "YLaBPa_cell-columngap-lg-3",
  "cell-columngap-lg-4": "YLaBPa_cell-columngap-lg-4",
  "cell-columngap-lg-5": "YLaBPa_cell-columngap-lg-5",
  "cell-columngap-lg-6": "YLaBPa_cell-columngap-lg-6",
  "cell-columngap-lg-7": "YLaBPa_cell-columngap-lg-7",
  "cell-columngap-lg-8": "YLaBPa_cell-columngap-lg-8",
  "cell-columngap-lg-9": "YLaBPa_cell-columngap-lg-9",
  "cell-columngap-md-1": "YLaBPa_cell-columngap-md-1",
  "cell-columngap-md-10": "YLaBPa_cell-columngap-md-10",
  "cell-columngap-md-11": "YLaBPa_cell-columngap-md-11",
  "cell-columngap-md-12": "YLaBPa_cell-columngap-md-12",
  "cell-columngap-md-13": "YLaBPa_cell-columngap-md-13",
  "cell-columngap-md-14": "YLaBPa_cell-columngap-md-14",
  "cell-columngap-md-2": "YLaBPa_cell-columngap-md-2",
  "cell-columngap-md-3": "YLaBPa_cell-columngap-md-3",
  "cell-columngap-md-4": "YLaBPa_cell-columngap-md-4",
  "cell-columngap-md-5": "YLaBPa_cell-columngap-md-5",
  "cell-columngap-md-6": "YLaBPa_cell-columngap-md-6",
  "cell-columngap-md-7": "YLaBPa_cell-columngap-md-7",
  "cell-columngap-md-8": "YLaBPa_cell-columngap-md-8",
  "cell-columngap-md-9": "YLaBPa_cell-columngap-md-9",
  "cell-columngap-sm-1": "YLaBPa_cell-columngap-sm-1",
  "cell-columngap-sm-10": "YLaBPa_cell-columngap-sm-10",
  "cell-columngap-sm-11": "YLaBPa_cell-columngap-sm-11",
  "cell-columngap-sm-12": "YLaBPa_cell-columngap-sm-12",
  "cell-columngap-sm-13": "YLaBPa_cell-columngap-sm-13",
  "cell-columngap-sm-14": "YLaBPa_cell-columngap-sm-14",
  "cell-columngap-sm-2": "YLaBPa_cell-columngap-sm-2",
  "cell-columngap-sm-3": "YLaBPa_cell-columngap-sm-3",
  "cell-columngap-sm-4": "YLaBPa_cell-columngap-sm-4",
  "cell-columngap-sm-5": "YLaBPa_cell-columngap-sm-5",
  "cell-columngap-sm-6": "YLaBPa_cell-columngap-sm-6",
  "cell-columngap-sm-7": "YLaBPa_cell-columngap-sm-7",
  "cell-columngap-sm-8": "YLaBPa_cell-columngap-sm-8",
  "cell-columngap-sm-9": "YLaBPa_cell-columngap-sm-9",
  "cell-columngap-xl-1": "YLaBPa_cell-columngap-xl-1",
  "cell-columngap-xl-10": "YLaBPa_cell-columngap-xl-10",
  "cell-columngap-xl-11": "YLaBPa_cell-columngap-xl-11",
  "cell-columngap-xl-12": "YLaBPa_cell-columngap-xl-12",
  "cell-columngap-xl-13": "YLaBPa_cell-columngap-xl-13",
  "cell-columngap-xl-14": "YLaBPa_cell-columngap-xl-14",
  "cell-columngap-xl-2": "YLaBPa_cell-columngap-xl-2",
  "cell-columngap-xl-3": "YLaBPa_cell-columngap-xl-3",
  "cell-columngap-xl-4": "YLaBPa_cell-columngap-xl-4",
  "cell-columngap-xl-5": "YLaBPa_cell-columngap-xl-5",
  "cell-columngap-xl-6": "YLaBPa_cell-columngap-xl-6",
  "cell-columngap-xl-7": "YLaBPa_cell-columngap-xl-7",
  "cell-columngap-xl-8": "YLaBPa_cell-columngap-xl-8",
  "cell-columngap-xl-9": "YLaBPa_cell-columngap-xl-9",
  "cell-dsp-lg--moz-initial": "YLaBPa_cell-dsp-lg--moz-initial",
  "cell-dsp-lg--ms-flexbox": "YLaBPa_cell-dsp-lg--ms-flexbox",
  "cell-dsp-lg--ms-grid": "YLaBPa_cell-dsp-lg--ms-grid",
  "cell-dsp-lg--webkit-flex": "YLaBPa_cell-dsp-lg--webkit-flex",
  "cell-dsp-lg-block": "YLaBPa_cell-dsp-lg-block",
  "cell-dsp-lg-contents": "YLaBPa_cell-dsp-lg-contents",
  "cell-dsp-lg-flex": "YLaBPa_cell-dsp-lg-flex",
  "cell-dsp-lg-flow": "YLaBPa_cell-dsp-lg-flow",
  "cell-dsp-lg-flow-root": "YLaBPa_cell-dsp-lg-flow-root",
  "cell-dsp-lg-grid": "YLaBPa_cell-dsp-lg-grid",
  "cell-dsp-lg-inherit": "YLaBPa_cell-dsp-lg-inherit",
  "cell-dsp-lg-initial": "YLaBPa_cell-dsp-lg-initial",
  "cell-dsp-lg-inline": "YLaBPa_cell-dsp-lg-inline",
  "cell-dsp-lg-list-item": "YLaBPa_cell-dsp-lg-list-item",
  "cell-dsp-lg-none": "YLaBPa_cell-dsp-lg-none",
  "cell-dsp-lg-revert": "YLaBPa_cell-dsp-lg-revert",
  "cell-dsp-lg-ruby": "YLaBPa_cell-dsp-lg-ruby",
  "cell-dsp-lg-run-in": "YLaBPa_cell-dsp-lg-run-in",
  "cell-dsp-lg-table": "YLaBPa_cell-dsp-lg-table",
  "cell-dsp-lg-unset": "YLaBPa_cell-dsp-lg-unset",
  "cell-dsp-md--moz-initial": "YLaBPa_cell-dsp-md--moz-initial",
  "cell-dsp-md--ms-flexbox": "YLaBPa_cell-dsp-md--ms-flexbox",
  "cell-dsp-md--ms-grid": "YLaBPa_cell-dsp-md--ms-grid",
  "cell-dsp-md--webkit-flex": "YLaBPa_cell-dsp-md--webkit-flex",
  "cell-dsp-md-block": "YLaBPa_cell-dsp-md-block",
  "cell-dsp-md-contents": "YLaBPa_cell-dsp-md-contents",
  "cell-dsp-md-flex": "YLaBPa_cell-dsp-md-flex",
  "cell-dsp-md-flow": "YLaBPa_cell-dsp-md-flow",
  "cell-dsp-md-flow-root": "YLaBPa_cell-dsp-md-flow-root",
  "cell-dsp-md-grid": "YLaBPa_cell-dsp-md-grid",
  "cell-dsp-md-inherit": "YLaBPa_cell-dsp-md-inherit",
  "cell-dsp-md-initial": "YLaBPa_cell-dsp-md-initial",
  "cell-dsp-md-inline": "YLaBPa_cell-dsp-md-inline",
  "cell-dsp-md-list-item": "YLaBPa_cell-dsp-md-list-item",
  "cell-dsp-md-none": "YLaBPa_cell-dsp-md-none",
  "cell-dsp-md-revert": "YLaBPa_cell-dsp-md-revert",
  "cell-dsp-md-ruby": "YLaBPa_cell-dsp-md-ruby",
  "cell-dsp-md-run-in": "YLaBPa_cell-dsp-md-run-in",
  "cell-dsp-md-table": "YLaBPa_cell-dsp-md-table",
  "cell-dsp-md-unset": "YLaBPa_cell-dsp-md-unset",
  "cell-dsp-sm--moz-initial": "YLaBPa_cell-dsp-sm--moz-initial",
  "cell-dsp-sm--ms-flexbox": "YLaBPa_cell-dsp-sm--ms-flexbox",
  "cell-dsp-sm--ms-grid": "YLaBPa_cell-dsp-sm--ms-grid",
  "cell-dsp-sm--webkit-flex": "YLaBPa_cell-dsp-sm--webkit-flex",
  "cell-dsp-sm-block": "YLaBPa_cell-dsp-sm-block",
  "cell-dsp-sm-contents": "YLaBPa_cell-dsp-sm-contents",
  "cell-dsp-sm-flex": "YLaBPa_cell-dsp-sm-flex",
  "cell-dsp-sm-flow": "YLaBPa_cell-dsp-sm-flow",
  "cell-dsp-sm-flow-root": "YLaBPa_cell-dsp-sm-flow-root",
  "cell-dsp-sm-grid": "YLaBPa_cell-dsp-sm-grid",
  "cell-dsp-sm-inherit": "YLaBPa_cell-dsp-sm-inherit",
  "cell-dsp-sm-initial": "YLaBPa_cell-dsp-sm-initial",
  "cell-dsp-sm-inline": "YLaBPa_cell-dsp-sm-inline",
  "cell-dsp-sm-list-item": "YLaBPa_cell-dsp-sm-list-item",
  "cell-dsp-sm-none": "YLaBPa_cell-dsp-sm-none",
  "cell-dsp-sm-revert": "YLaBPa_cell-dsp-sm-revert",
  "cell-dsp-sm-ruby": "YLaBPa_cell-dsp-sm-ruby",
  "cell-dsp-sm-run-in": "YLaBPa_cell-dsp-sm-run-in",
  "cell-dsp-sm-table": "YLaBPa_cell-dsp-sm-table",
  "cell-dsp-sm-unset": "YLaBPa_cell-dsp-sm-unset",
  "cell-dsp-xl--moz-initial": "YLaBPa_cell-dsp-xl--moz-initial",
  "cell-dsp-xl--ms-flexbox": "YLaBPa_cell-dsp-xl--ms-flexbox",
  "cell-dsp-xl--ms-grid": "YLaBPa_cell-dsp-xl--ms-grid",
  "cell-dsp-xl--webkit-flex": "YLaBPa_cell-dsp-xl--webkit-flex",
  "cell-dsp-xl-block": "YLaBPa_cell-dsp-xl-block",
  "cell-dsp-xl-contents": "YLaBPa_cell-dsp-xl-contents",
  "cell-dsp-xl-flex": "YLaBPa_cell-dsp-xl-flex",
  "cell-dsp-xl-flow": "YLaBPa_cell-dsp-xl-flow",
  "cell-dsp-xl-flow-root": "YLaBPa_cell-dsp-xl-flow-root",
  "cell-dsp-xl-grid": "YLaBPa_cell-dsp-xl-grid",
  "cell-dsp-xl-inherit": "YLaBPa_cell-dsp-xl-inherit",
  "cell-dsp-xl-initial": "YLaBPa_cell-dsp-xl-initial",
  "cell-dsp-xl-inline": "YLaBPa_cell-dsp-xl-inline",
  "cell-dsp-xl-list-item": "YLaBPa_cell-dsp-xl-list-item",
  "cell-dsp-xl-none": "YLaBPa_cell-dsp-xl-none",
  "cell-dsp-xl-revert": "YLaBPa_cell-dsp-xl-revert",
  "cell-dsp-xl-ruby": "YLaBPa_cell-dsp-xl-ruby",
  "cell-dsp-xl-run-in": "YLaBPa_cell-dsp-xl-run-in",
  "cell-dsp-xl-table": "YLaBPa_cell-dsp-xl-table",
  "cell-dsp-xl-unset": "YLaBPa_cell-dsp-xl-unset",
  "cell-height-lg-1": "YLaBPa_cell-height-lg-1",
  "cell-height-lg-10": "YLaBPa_cell-height-lg-10",
  "cell-height-lg-11": "YLaBPa_cell-height-lg-11",
  "cell-height-lg-12": "YLaBPa_cell-height-lg-12",
  "cell-height-lg-13": "YLaBPa_cell-height-lg-13",
  "cell-height-lg-14": "YLaBPa_cell-height-lg-14",
  "cell-height-lg-2": "YLaBPa_cell-height-lg-2",
  "cell-height-lg-3": "YLaBPa_cell-height-lg-3",
  "cell-height-lg-4": "YLaBPa_cell-height-lg-4",
  "cell-height-lg-5": "YLaBPa_cell-height-lg-5",
  "cell-height-lg-6": "YLaBPa_cell-height-lg-6",
  "cell-height-lg-7": "YLaBPa_cell-height-lg-7",
  "cell-height-lg-8": "YLaBPa_cell-height-lg-8",
  "cell-height-lg-9": "YLaBPa_cell-height-lg-9",
  "cell-height-md-1": "YLaBPa_cell-height-md-1",
  "cell-height-md-10": "YLaBPa_cell-height-md-10",
  "cell-height-md-11": "YLaBPa_cell-height-md-11",
  "cell-height-md-12": "YLaBPa_cell-height-md-12",
  "cell-height-md-13": "YLaBPa_cell-height-md-13",
  "cell-height-md-14": "YLaBPa_cell-height-md-14",
  "cell-height-md-2": "YLaBPa_cell-height-md-2",
  "cell-height-md-3": "YLaBPa_cell-height-md-3",
  "cell-height-md-4": "YLaBPa_cell-height-md-4",
  "cell-height-md-5": "YLaBPa_cell-height-md-5",
  "cell-height-md-6": "YLaBPa_cell-height-md-6",
  "cell-height-md-7": "YLaBPa_cell-height-md-7",
  "cell-height-md-8": "YLaBPa_cell-height-md-8",
  "cell-height-md-9": "YLaBPa_cell-height-md-9",
  "cell-height-sm-1": "YLaBPa_cell-height-sm-1",
  "cell-height-sm-10": "YLaBPa_cell-height-sm-10",
  "cell-height-sm-11": "YLaBPa_cell-height-sm-11",
  "cell-height-sm-12": "YLaBPa_cell-height-sm-12",
  "cell-height-sm-13": "YLaBPa_cell-height-sm-13",
  "cell-height-sm-14": "YLaBPa_cell-height-sm-14",
  "cell-height-sm-2": "YLaBPa_cell-height-sm-2",
  "cell-height-sm-3": "YLaBPa_cell-height-sm-3",
  "cell-height-sm-4": "YLaBPa_cell-height-sm-4",
  "cell-height-sm-5": "YLaBPa_cell-height-sm-5",
  "cell-height-sm-6": "YLaBPa_cell-height-sm-6",
  "cell-height-sm-7": "YLaBPa_cell-height-sm-7",
  "cell-height-sm-8": "YLaBPa_cell-height-sm-8",
  "cell-height-sm-9": "YLaBPa_cell-height-sm-9",
  "cell-height-xl-1": "YLaBPa_cell-height-xl-1",
  "cell-height-xl-10": "YLaBPa_cell-height-xl-10",
  "cell-height-xl-11": "YLaBPa_cell-height-xl-11",
  "cell-height-xl-12": "YLaBPa_cell-height-xl-12",
  "cell-height-xl-13": "YLaBPa_cell-height-xl-13",
  "cell-height-xl-14": "YLaBPa_cell-height-xl-14",
  "cell-height-xl-2": "YLaBPa_cell-height-xl-2",
  "cell-height-xl-3": "YLaBPa_cell-height-xl-3",
  "cell-height-xl-4": "YLaBPa_cell-height-xl-4",
  "cell-height-xl-5": "YLaBPa_cell-height-xl-5",
  "cell-height-xl-6": "YLaBPa_cell-height-xl-6",
  "cell-height-xl-7": "YLaBPa_cell-height-xl-7",
  "cell-height-xl-8": "YLaBPa_cell-height-xl-8",
  "cell-height-xl-9": "YLaBPa_cell-height-xl-9",
  "cell-row-lg-1": "YLaBPa_cell-row-lg-1",
  "cell-row-lg-2": "YLaBPa_cell-row-lg-2",
  "cell-row-lg-3": "YLaBPa_cell-row-lg-3",
  "cell-row-lg-4": "YLaBPa_cell-row-lg-4",
  "cell-row-lg-5": "YLaBPa_cell-row-lg-5",
  "cell-row-lg-6": "YLaBPa_cell-row-lg-6",
  "cell-row-lg-auto": "YLaBPa_cell-row-lg-auto",
  "cell-row-lg-span-1": "YLaBPa_cell-row-lg-span-1",
  "cell-row-lg-span-10": "YLaBPa_cell-row-lg-span-10",
  "cell-row-lg-span-11": "YLaBPa_cell-row-lg-span-11",
  "cell-row-lg-span-12": "YLaBPa_cell-row-lg-span-12",
  "cell-row-lg-span-2": "YLaBPa_cell-row-lg-span-2",
  "cell-row-lg-span-3": "YLaBPa_cell-row-lg-span-3",
  "cell-row-lg-span-4": "YLaBPa_cell-row-lg-span-4",
  "cell-row-lg-span-5": "YLaBPa_cell-row-lg-span-5",
  "cell-row-lg-span-6": "YLaBPa_cell-row-lg-span-6",
  "cell-row-lg-span-7": "YLaBPa_cell-row-lg-span-7",
  "cell-row-lg-span-8": "YLaBPa_cell-row-lg-span-8",
  "cell-row-lg-span-9": "YLaBPa_cell-row-lg-span-9",
  "cell-row-md-1": "YLaBPa_cell-row-md-1",
  "cell-row-md-2": "YLaBPa_cell-row-md-2",
  "cell-row-md-3": "YLaBPa_cell-row-md-3",
  "cell-row-md-4": "YLaBPa_cell-row-md-4",
  "cell-row-md-5": "YLaBPa_cell-row-md-5",
  "cell-row-md-6": "YLaBPa_cell-row-md-6",
  "cell-row-md-auto": "YLaBPa_cell-row-md-auto",
  "cell-row-md-span-1": "YLaBPa_cell-row-md-span-1",
  "cell-row-md-span-10": "YLaBPa_cell-row-md-span-10",
  "cell-row-md-span-11": "YLaBPa_cell-row-md-span-11",
  "cell-row-md-span-12": "YLaBPa_cell-row-md-span-12",
  "cell-row-md-span-2": "YLaBPa_cell-row-md-span-2",
  "cell-row-md-span-3": "YLaBPa_cell-row-md-span-3",
  "cell-row-md-span-4": "YLaBPa_cell-row-md-span-4",
  "cell-row-md-span-5": "YLaBPa_cell-row-md-span-5",
  "cell-row-md-span-6": "YLaBPa_cell-row-md-span-6",
  "cell-row-md-span-7": "YLaBPa_cell-row-md-span-7",
  "cell-row-md-span-8": "YLaBPa_cell-row-md-span-8",
  "cell-row-md-span-9": "YLaBPa_cell-row-md-span-9",
  "cell-row-sm-1": "YLaBPa_cell-row-sm-1",
  "cell-row-sm-2": "YLaBPa_cell-row-sm-2",
  "cell-row-sm-3": "YLaBPa_cell-row-sm-3",
  "cell-row-sm-4": "YLaBPa_cell-row-sm-4",
  "cell-row-sm-5": "YLaBPa_cell-row-sm-5",
  "cell-row-sm-6": "YLaBPa_cell-row-sm-6",
  "cell-row-sm-auto": "YLaBPa_cell-row-sm-auto",
  "cell-row-sm-span-1": "YLaBPa_cell-row-sm-span-1",
  "cell-row-sm-span-10": "YLaBPa_cell-row-sm-span-10",
  "cell-row-sm-span-11": "YLaBPa_cell-row-sm-span-11",
  "cell-row-sm-span-12": "YLaBPa_cell-row-sm-span-12",
  "cell-row-sm-span-2": "YLaBPa_cell-row-sm-span-2",
  "cell-row-sm-span-3": "YLaBPa_cell-row-sm-span-3",
  "cell-row-sm-span-4": "YLaBPa_cell-row-sm-span-4",
  "cell-row-sm-span-5": "YLaBPa_cell-row-sm-span-5",
  "cell-row-sm-span-6": "YLaBPa_cell-row-sm-span-6",
  "cell-row-sm-span-7": "YLaBPa_cell-row-sm-span-7",
  "cell-row-sm-span-8": "YLaBPa_cell-row-sm-span-8",
  "cell-row-sm-span-9": "YLaBPa_cell-row-sm-span-9",
  "cell-row-xl-1": "YLaBPa_cell-row-xl-1",
  "cell-row-xl-2": "YLaBPa_cell-row-xl-2",
  "cell-row-xl-3": "YLaBPa_cell-row-xl-3",
  "cell-row-xl-4": "YLaBPa_cell-row-xl-4",
  "cell-row-xl-5": "YLaBPa_cell-row-xl-5",
  "cell-row-xl-6": "YLaBPa_cell-row-xl-6",
  "cell-row-xl-auto": "YLaBPa_cell-row-xl-auto",
  "cell-row-xl-span-1": "YLaBPa_cell-row-xl-span-1",
  "cell-row-xl-span-10": "YLaBPa_cell-row-xl-span-10",
  "cell-row-xl-span-11": "YLaBPa_cell-row-xl-span-11",
  "cell-row-xl-span-12": "YLaBPa_cell-row-xl-span-12",
  "cell-row-xl-span-2": "YLaBPa_cell-row-xl-span-2",
  "cell-row-xl-span-3": "YLaBPa_cell-row-xl-span-3",
  "cell-row-xl-span-4": "YLaBPa_cell-row-xl-span-4",
  "cell-row-xl-span-5": "YLaBPa_cell-row-xl-span-5",
  "cell-row-xl-span-6": "YLaBPa_cell-row-xl-span-6",
  "cell-row-xl-span-7": "YLaBPa_cell-row-xl-span-7",
  "cell-row-xl-span-8": "YLaBPa_cell-row-xl-span-8",
  "cell-row-xl-span-9": "YLaBPa_cell-row-xl-span-9",
  "cell-rowgap-lg-1": "YLaBPa_cell-rowgap-lg-1",
  "cell-rowgap-lg-10": "YLaBPa_cell-rowgap-lg-10",
  "cell-rowgap-lg-11": "YLaBPa_cell-rowgap-lg-11",
  "cell-rowgap-lg-12": "YLaBPa_cell-rowgap-lg-12",
  "cell-rowgap-lg-13": "YLaBPa_cell-rowgap-lg-13",
  "cell-rowgap-lg-14": "YLaBPa_cell-rowgap-lg-14",
  "cell-rowgap-lg-2": "YLaBPa_cell-rowgap-lg-2",
  "cell-rowgap-lg-3": "YLaBPa_cell-rowgap-lg-3",
  "cell-rowgap-lg-4": "YLaBPa_cell-rowgap-lg-4",
  "cell-rowgap-lg-5": "YLaBPa_cell-rowgap-lg-5",
  "cell-rowgap-lg-6": "YLaBPa_cell-rowgap-lg-6",
  "cell-rowgap-lg-7": "YLaBPa_cell-rowgap-lg-7",
  "cell-rowgap-lg-8": "YLaBPa_cell-rowgap-lg-8",
  "cell-rowgap-lg-9": "YLaBPa_cell-rowgap-lg-9",
  "cell-rowgap-md-1": "YLaBPa_cell-rowgap-md-1",
  "cell-rowgap-md-10": "YLaBPa_cell-rowgap-md-10",
  "cell-rowgap-md-11": "YLaBPa_cell-rowgap-md-11",
  "cell-rowgap-md-12": "YLaBPa_cell-rowgap-md-12",
  "cell-rowgap-md-13": "YLaBPa_cell-rowgap-md-13",
  "cell-rowgap-md-14": "YLaBPa_cell-rowgap-md-14",
  "cell-rowgap-md-2": "YLaBPa_cell-rowgap-md-2",
  "cell-rowgap-md-3": "YLaBPa_cell-rowgap-md-3",
  "cell-rowgap-md-4": "YLaBPa_cell-rowgap-md-4",
  "cell-rowgap-md-5": "YLaBPa_cell-rowgap-md-5",
  "cell-rowgap-md-6": "YLaBPa_cell-rowgap-md-6",
  "cell-rowgap-md-7": "YLaBPa_cell-rowgap-md-7",
  "cell-rowgap-md-8": "YLaBPa_cell-rowgap-md-8",
  "cell-rowgap-md-9": "YLaBPa_cell-rowgap-md-9",
  "cell-rowgap-sm-1": "YLaBPa_cell-rowgap-sm-1",
  "cell-rowgap-sm-10": "YLaBPa_cell-rowgap-sm-10",
  "cell-rowgap-sm-11": "YLaBPa_cell-rowgap-sm-11",
  "cell-rowgap-sm-12": "YLaBPa_cell-rowgap-sm-12",
  "cell-rowgap-sm-13": "YLaBPa_cell-rowgap-sm-13",
  "cell-rowgap-sm-14": "YLaBPa_cell-rowgap-sm-14",
  "cell-rowgap-sm-2": "YLaBPa_cell-rowgap-sm-2",
  "cell-rowgap-sm-3": "YLaBPa_cell-rowgap-sm-3",
  "cell-rowgap-sm-4": "YLaBPa_cell-rowgap-sm-4",
  "cell-rowgap-sm-5": "YLaBPa_cell-rowgap-sm-5",
  "cell-rowgap-sm-6": "YLaBPa_cell-rowgap-sm-6",
  "cell-rowgap-sm-7": "YLaBPa_cell-rowgap-sm-7",
  "cell-rowgap-sm-8": "YLaBPa_cell-rowgap-sm-8",
  "cell-rowgap-sm-9": "YLaBPa_cell-rowgap-sm-9",
  "cell-rowgap-xl-1": "YLaBPa_cell-rowgap-xl-1",
  "cell-rowgap-xl-10": "YLaBPa_cell-rowgap-xl-10",
  "cell-rowgap-xl-11": "YLaBPa_cell-rowgap-xl-11",
  "cell-rowgap-xl-12": "YLaBPa_cell-rowgap-xl-12",
  "cell-rowgap-xl-13": "YLaBPa_cell-rowgap-xl-13",
  "cell-rowgap-xl-14": "YLaBPa_cell-rowgap-xl-14",
  "cell-rowgap-xl-2": "YLaBPa_cell-rowgap-xl-2",
  "cell-rowgap-xl-3": "YLaBPa_cell-rowgap-xl-3",
  "cell-rowgap-xl-4": "YLaBPa_cell-rowgap-xl-4",
  "cell-rowgap-xl-5": "YLaBPa_cell-rowgap-xl-5",
  "cell-rowgap-xl-6": "YLaBPa_cell-rowgap-xl-6",
  "cell-rowgap-xl-7": "YLaBPa_cell-rowgap-xl-7",
  "cell-rowgap-xl-8": "YLaBPa_cell-rowgap-xl-8",
  "cell-rowgap-xl-9": "YLaBPa_cell-rowgap-xl-9",
  "cell-ta-lg-center": "YLaBPa_cell-ta-lg-center",
  "cell-ta-lg-end": "YLaBPa_cell-ta-lg-end",
  "cell-ta-lg-justify": "YLaBPa_cell-ta-lg-justify",
  "cell-ta-lg-left": "YLaBPa_cell-ta-lg-left",
  "cell-ta-lg-match-parent": "YLaBPa_cell-ta-lg-match-parent",
  "cell-ta-lg-right": "YLaBPa_cell-ta-lg-right",
  "cell-ta-lg-start": "YLaBPa_cell-ta-lg-start",
  "cell-ta-md-center": "YLaBPa_cell-ta-md-center",
  "cell-ta-md-end": "YLaBPa_cell-ta-md-end",
  "cell-ta-md-justify": "YLaBPa_cell-ta-md-justify",
  "cell-ta-md-left": "YLaBPa_cell-ta-md-left",
  "cell-ta-md-match-parent": "YLaBPa_cell-ta-md-match-parent",
  "cell-ta-md-right": "YLaBPa_cell-ta-md-right",
  "cell-ta-md-start": "YLaBPa_cell-ta-md-start",
  "cell-ta-sm-center": "YLaBPa_cell-ta-sm-center",
  "cell-ta-sm-end": "YLaBPa_cell-ta-sm-end",
  "cell-ta-sm-justify": "YLaBPa_cell-ta-sm-justify",
  "cell-ta-sm-left": "YLaBPa_cell-ta-sm-left",
  "cell-ta-sm-match-parent": "YLaBPa_cell-ta-sm-match-parent",
  "cell-ta-sm-right": "YLaBPa_cell-ta-sm-right",
  "cell-ta-sm-start": "YLaBPa_cell-ta-sm-start",
  "cell-ta-xl-center": "YLaBPa_cell-ta-xl-center",
  "cell-ta-xl-end": "YLaBPa_cell-ta-xl-end",
  "cell-ta-xl-justify": "YLaBPa_cell-ta-xl-justify",
  "cell-ta-xl-left": "YLaBPa_cell-ta-xl-left",
  "cell-ta-xl-match-parent": "YLaBPa_cell-ta-xl-match-parent",
  "cell-ta-xl-right": "YLaBPa_cell-ta-xl-right",
  "cell-ta-xl-start": "YLaBPa_cell-ta-xl-start",
  "cell-width-lg-1": "YLaBPa_cell-width-lg-1",
  "cell-width-lg-10": "YLaBPa_cell-width-lg-10",
  "cell-width-lg-11": "YLaBPa_cell-width-lg-11",
  "cell-width-lg-12": "YLaBPa_cell-width-lg-12",
  "cell-width-lg-13": "YLaBPa_cell-width-lg-13",
  "cell-width-lg-14": "YLaBPa_cell-width-lg-14",
  "cell-width-lg-2": "YLaBPa_cell-width-lg-2",
  "cell-width-lg-3": "YLaBPa_cell-width-lg-3",
  "cell-width-lg-4": "YLaBPa_cell-width-lg-4",
  "cell-width-lg-5": "YLaBPa_cell-width-lg-5",
  "cell-width-lg-6": "YLaBPa_cell-width-lg-6",
  "cell-width-lg-7": "YLaBPa_cell-width-lg-7",
  "cell-width-lg-8": "YLaBPa_cell-width-lg-8",
  "cell-width-lg-9": "YLaBPa_cell-width-lg-9",
  "cell-width-md-1": "YLaBPa_cell-width-md-1",
  "cell-width-md-10": "YLaBPa_cell-width-md-10",
  "cell-width-md-11": "YLaBPa_cell-width-md-11",
  "cell-width-md-12": "YLaBPa_cell-width-md-12",
  "cell-width-md-13": "YLaBPa_cell-width-md-13",
  "cell-width-md-14": "YLaBPa_cell-width-md-14",
  "cell-width-md-2": "YLaBPa_cell-width-md-2",
  "cell-width-md-3": "YLaBPa_cell-width-md-3",
  "cell-width-md-4": "YLaBPa_cell-width-md-4",
  "cell-width-md-5": "YLaBPa_cell-width-md-5",
  "cell-width-md-6": "YLaBPa_cell-width-md-6",
  "cell-width-md-7": "YLaBPa_cell-width-md-7",
  "cell-width-md-8": "YLaBPa_cell-width-md-8",
  "cell-width-md-9": "YLaBPa_cell-width-md-9",
  "cell-width-sm-1": "YLaBPa_cell-width-sm-1",
  "cell-width-sm-10": "YLaBPa_cell-width-sm-10",
  "cell-width-sm-11": "YLaBPa_cell-width-sm-11",
  "cell-width-sm-12": "YLaBPa_cell-width-sm-12",
  "cell-width-sm-13": "YLaBPa_cell-width-sm-13",
  "cell-width-sm-14": "YLaBPa_cell-width-sm-14",
  "cell-width-sm-2": "YLaBPa_cell-width-sm-2",
  "cell-width-sm-3": "YLaBPa_cell-width-sm-3",
  "cell-width-sm-4": "YLaBPa_cell-width-sm-4",
  "cell-width-sm-5": "YLaBPa_cell-width-sm-5",
  "cell-width-sm-6": "YLaBPa_cell-width-sm-6",
  "cell-width-sm-7": "YLaBPa_cell-width-sm-7",
  "cell-width-sm-8": "YLaBPa_cell-width-sm-8",
  "cell-width-sm-9": "YLaBPa_cell-width-sm-9",
  "cell-width-xl-1": "YLaBPa_cell-width-xl-1",
  "cell-width-xl-10": "YLaBPa_cell-width-xl-10",
  "cell-width-xl-11": "YLaBPa_cell-width-xl-11",
  "cell-width-xl-12": "YLaBPa_cell-width-xl-12",
  "cell-width-xl-13": "YLaBPa_cell-width-xl-13",
  "cell-width-xl-14": "YLaBPa_cell-width-xl-14",
  "cell-width-xl-2": "YLaBPa_cell-width-xl-2",
  "cell-width-xl-3": "YLaBPa_cell-width-xl-3",
  "cell-width-xl-4": "YLaBPa_cell-width-xl-4",
  "cell-width-xl-5": "YLaBPa_cell-width-xl-5",
  "cell-width-xl-6": "YLaBPa_cell-width-xl-6",
  "cell-width-xl-7": "YLaBPa_cell-width-xl-7",
  "cell-width-xl-8": "YLaBPa_cell-width-xl-8",
  "cell-width-xl-9": "YLaBPa_cell-width-xl-9",
  "jc-lg-center": "YLaBPa_jc-lg-center",
  "jc-lg-end": "YLaBPa_jc-lg-end",
  "jc-lg-flex-end": "YLaBPa_jc-lg-flex-end",
  "jc-lg-flex-start": "YLaBPa_jc-lg-flex-start",
  "jc-lg-left": "YLaBPa_jc-lg-left",
  "jc-lg-normal": "YLaBPa_jc-lg-normal",
  "jc-lg-right": "YLaBPa_jc-lg-right",
  "jc-lg-space-around": "YLaBPa_jc-lg-space-around",
  "jc-lg-space-between": "YLaBPa_jc-lg-space-between",
  "jc-lg-space-evenly": "YLaBPa_jc-lg-space-evenly",
  "jc-lg-start": "YLaBPa_jc-lg-start",
  "jc-lg-stretch": "YLaBPa_jc-lg-stretch",
  "jc-md-center": "YLaBPa_jc-md-center",
  "jc-md-end": "YLaBPa_jc-md-end",
  "jc-md-flex-end": "YLaBPa_jc-md-flex-end",
  "jc-md-flex-start": "YLaBPa_jc-md-flex-start",
  "jc-md-left": "YLaBPa_jc-md-left",
  "jc-md-normal": "YLaBPa_jc-md-normal",
  "jc-md-right": "YLaBPa_jc-md-right",
  "jc-md-space-around": "YLaBPa_jc-md-space-around",
  "jc-md-space-between": "YLaBPa_jc-md-space-between",
  "jc-md-space-evenly": "YLaBPa_jc-md-space-evenly",
  "jc-md-start": "YLaBPa_jc-md-start",
  "jc-md-stretch": "YLaBPa_jc-md-stretch",
  "jc-sm-center": "YLaBPa_jc-sm-center",
  "jc-sm-end": "YLaBPa_jc-sm-end",
  "jc-sm-flex-end": "YLaBPa_jc-sm-flex-end",
  "jc-sm-flex-start": "YLaBPa_jc-sm-flex-start",
  "jc-sm-left": "YLaBPa_jc-sm-left",
  "jc-sm-normal": "YLaBPa_jc-sm-normal",
  "jc-sm-right": "YLaBPa_jc-sm-right",
  "jc-sm-space-around": "YLaBPa_jc-sm-space-around",
  "jc-sm-space-between": "YLaBPa_jc-sm-space-between",
  "jc-sm-space-evenly": "YLaBPa_jc-sm-space-evenly",
  "jc-sm-start": "YLaBPa_jc-sm-start",
  "jc-sm-stretch": "YLaBPa_jc-sm-stretch",
  "jc-xl-center": "YLaBPa_jc-xl-center",
  "jc-xl-end": "YLaBPa_jc-xl-end",
  "jc-xl-flex-end": "YLaBPa_jc-xl-flex-end",
  "jc-xl-flex-start": "YLaBPa_jc-xl-flex-start",
  "jc-xl-left": "YLaBPa_jc-xl-left",
  "jc-xl-normal": "YLaBPa_jc-xl-normal",
  "jc-xl-right": "YLaBPa_jc-xl-right",
  "jc-xl-space-around": "YLaBPa_jc-xl-space-around",
  "jc-xl-space-between": "YLaBPa_jc-xl-space-between",
  "jc-xl-space-evenly": "YLaBPa_jc-xl-space-evenly",
  "jc-xl-start": "YLaBPa_jc-xl-start",
  "jc-xl-stretch": "YLaBPa_jc-xl-stretch",
  "ji-lg-baseline": "YLaBPa_ji-lg-baseline",
  "ji-lg-center": "YLaBPa_ji-lg-center",
  "ji-lg-end": "YLaBPa_ji-lg-end",
  "ji-lg-flex-end": "YLaBPa_ji-lg-flex-end",
  "ji-lg-flex-start": "YLaBPa_ji-lg-flex-start",
  "ji-lg-left": "YLaBPa_ji-lg-left",
  "ji-lg-normal": "YLaBPa_ji-lg-normal",
  "ji-lg-right": "YLaBPa_ji-lg-right",
  "ji-lg-self-end": "YLaBPa_ji-lg-self-end",
  "ji-lg-self-start": "YLaBPa_ji-lg-self-start",
  "ji-lg-start": "YLaBPa_ji-lg-start",
  "ji-lg-stretch": "YLaBPa_ji-lg-stretch",
  "ji-md-baseline": "YLaBPa_ji-md-baseline",
  "ji-md-center": "YLaBPa_ji-md-center",
  "ji-md-end": "YLaBPa_ji-md-end",
  "ji-md-flex-end": "YLaBPa_ji-md-flex-end",
  "ji-md-flex-start": "YLaBPa_ji-md-flex-start",
  "ji-md-left": "YLaBPa_ji-md-left",
  "ji-md-normal": "YLaBPa_ji-md-normal",
  "ji-md-right": "YLaBPa_ji-md-right",
  "ji-md-self-end": "YLaBPa_ji-md-self-end",
  "ji-md-self-start": "YLaBPa_ji-md-self-start",
  "ji-md-start": "YLaBPa_ji-md-start",
  "ji-md-stretch": "YLaBPa_ji-md-stretch",
  "ji-sm-baseline": "YLaBPa_ji-sm-baseline",
  "ji-sm-center": "YLaBPa_ji-sm-center",
  "ji-sm-end": "YLaBPa_ji-sm-end",
  "ji-sm-flex-end": "YLaBPa_ji-sm-flex-end",
  "ji-sm-flex-start": "YLaBPa_ji-sm-flex-start",
  "ji-sm-left": "YLaBPa_ji-sm-left",
  "ji-sm-normal": "YLaBPa_ji-sm-normal",
  "ji-sm-right": "YLaBPa_ji-sm-right",
  "ji-sm-self-end": "YLaBPa_ji-sm-self-end",
  "ji-sm-self-start": "YLaBPa_ji-sm-self-start",
  "ji-sm-start": "YLaBPa_ji-sm-start",
  "ji-sm-stretch": "YLaBPa_ji-sm-stretch",
  "ji-xl-baseline": "YLaBPa_ji-xl-baseline",
  "ji-xl-center": "YLaBPa_ji-xl-center",
  "ji-xl-end": "YLaBPa_ji-xl-end",
  "ji-xl-flex-end": "YLaBPa_ji-xl-flex-end",
  "ji-xl-flex-start": "YLaBPa_ji-xl-flex-start",
  "ji-xl-left": "YLaBPa_ji-xl-left",
  "ji-xl-normal": "YLaBPa_ji-xl-normal",
  "ji-xl-right": "YLaBPa_ji-xl-right",
  "ji-xl-self-end": "YLaBPa_ji-xl-self-end",
  "ji-xl-self-start": "YLaBPa_ji-xl-self-start",
  "ji-xl-start": "YLaBPa_ji-xl-start",
  "ji-xl-stretch": "YLaBPa_ji-xl-stretch",
  "js-lg-auto": "YLaBPa_js-lg-auto",
  "js-lg-baseline": "YLaBPa_js-lg-baseline",
  "js-lg-center": "YLaBPa_js-lg-center",
  "js-lg-end": "YLaBPa_js-lg-end",
  "js-lg-flex-end": "YLaBPa_js-lg-flex-end",
  "js-lg-flex-start": "YLaBPa_js-lg-flex-start",
  "js-lg-left": "YLaBPa_js-lg-left",
  "js-lg-normal": "YLaBPa_js-lg-normal",
  "js-lg-right": "YLaBPa_js-lg-right",
  "js-lg-self-end": "YLaBPa_js-lg-self-end",
  "js-lg-self-start": "YLaBPa_js-lg-self-start",
  "js-lg-start": "YLaBPa_js-lg-start",
  "js-lg-stretch": "YLaBPa_js-lg-stretch",
  "js-md-auto": "YLaBPa_js-md-auto",
  "js-md-baseline": "YLaBPa_js-md-baseline",
  "js-md-center": "YLaBPa_js-md-center",
  "js-md-end": "YLaBPa_js-md-end",
  "js-md-flex-end": "YLaBPa_js-md-flex-end",
  "js-md-flex-start": "YLaBPa_js-md-flex-start",
  "js-md-left": "YLaBPa_js-md-left",
  "js-md-normal": "YLaBPa_js-md-normal",
  "js-md-right": "YLaBPa_js-md-right",
  "js-md-self-end": "YLaBPa_js-md-self-end",
  "js-md-self-start": "YLaBPa_js-md-self-start",
  "js-md-start": "YLaBPa_js-md-start",
  "js-md-stretch": "YLaBPa_js-md-stretch",
  "js-sm-auto": "YLaBPa_js-sm-auto",
  "js-sm-baseline": "YLaBPa_js-sm-baseline",
  "js-sm-center": "YLaBPa_js-sm-center",
  "js-sm-end": "YLaBPa_js-sm-end",
  "js-sm-flex-end": "YLaBPa_js-sm-flex-end",
  "js-sm-flex-start": "YLaBPa_js-sm-flex-start",
  "js-sm-left": "YLaBPa_js-sm-left",
  "js-sm-normal": "YLaBPa_js-sm-normal",
  "js-sm-right": "YLaBPa_js-sm-right",
  "js-sm-self-end": "YLaBPa_js-sm-self-end",
  "js-sm-self-start": "YLaBPa_js-sm-self-start",
  "js-sm-start": "YLaBPa_js-sm-start",
  "js-sm-stretch": "YLaBPa_js-sm-stretch",
  "js-xl-auto": "YLaBPa_js-xl-auto",
  "js-xl-baseline": "YLaBPa_js-xl-baseline",
  "js-xl-center": "YLaBPa_js-xl-center",
  "js-xl-end": "YLaBPa_js-xl-end",
  "js-xl-flex-end": "YLaBPa_js-xl-flex-end",
  "js-xl-flex-start": "YLaBPa_js-xl-flex-start",
  "js-xl-left": "YLaBPa_js-xl-left",
  "js-xl-normal": "YLaBPa_js-xl-normal",
  "js-xl-right": "YLaBPa_js-xl-right",
  "js-xl-self-end": "YLaBPa_js-xl-self-end",
  "js-xl-self-start": "YLaBPa_js-xl-self-start",
  "js-xl-start": "YLaBPa_js-xl-start",
  "js-xl-stretch": "YLaBPa_js-xl-stretch",
});
